import React from 'react';
import { number } from 'prop-types';

const ProductPrice = ({ price }) => {
    return price === 0.0 ? (
        <span>Please call us for price on this product.</span>
    ): (
        <div
            className={'product-price-wrapper'}>
            <span
                className={'product-price'}>${(Math.round(price * 100) / 100).toFixed(2)}</span>
        </div>
    );
};

const ProductPriceProps = {
    price: number.isRequired,
};
ProductPrice.propTypes = ProductPriceProps;
export default ProductPrice;